/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { GetReportResponse } from '../model/getReportResponse';
import { PreApprovalStatusRequest } from '../model/preApprovalStatusRequest';
import { PreApprovalStatusResponse } from '../model/preApprovalStatusResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PreapprovalControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getReport
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<GetReportResponse>>;
    public getReportUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetReportResponse>>>;
    public getReportUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetReportResponse>>>;
    public getReportUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<GetReportResponse>>(`${this.basePath}/preapproval/getReport`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getpreapprovals
     * 
     * @param preApprovalRequest preApprovalRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getpreapprovalsUsingPOST(preApprovalRequest: PreApprovalStatusRequest, observe?: 'body', reportProgress?: boolean): Observable<PreApprovalStatusResponse>;
    public getpreapprovalsUsingPOST(preApprovalRequest: PreApprovalStatusRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PreApprovalStatusResponse>>;
    public getpreapprovalsUsingPOST(preApprovalRequest: PreApprovalStatusRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PreApprovalStatusResponse>>;
    public getpreapprovalsUsingPOST(preApprovalRequest: PreApprovalStatusRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (preApprovalRequest === null || preApprovalRequest === undefined) {
            throw new Error('Required parameter preApprovalRequest was null or undefined when calling getpreapprovalsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PreApprovalStatusResponse>(`${this.basePath}/preapproval/status`,
            preApprovalRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
